module.exports = __webpack_public_path__ + "img/shipo-icon-order-bottom.369a99ed.svg";